window.fisherAnalytics.cart = {
    version: '1.0.0',
    init: function() {
        if ($.cookie('CART_ID') || localStorage.getItem("CART_ID")) {
            this.retrieveAndSetCartDataWithLimit(20);
        } else {
            if(LocalePath.getCountry() === 'US'){
                localStorage.removeItem('cartDetails'); //TODO Ask Colton about this
            }
        }
        // Check if callMinifiedCart session storage item exists
        if (sessionStorage.getItem('callMinifiedCart')) {
            this.callMinifiedCart();
        }
    },
    //dispatches event, saves cart details to local storage, and removes cart data
    cartEmptyEvent: function(){
        if (window.digitalData && window.digitalData.cart) {
            const cart = window.digitalData.cart;
            const payload = {
                cartId: cart.id || "",
                subTotal: cart.subtotal || 0.00,
                products: []
            };
            if (cart.products) {
                payload.products = Object.values(cart.products).map(product => ({
                    name: product.name,
                    sku: product.sku,
                    price: product.price,
                    quantity: product.quantity,
                    variation: product.variation,
                    discount: ""
                }));
            }
            const cartEmptyEvent = new CustomEvent('cartEmpty', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartEmptyEvent);
        }
        delete window.digitalData.cart;
        localStorage.removeItem('cartDetails');
        localStorage.removeItem('cartFindingMethod');
    },
    dispatchEnhancedCartAdd: function(data, requestParams, allLineItems) {
        try {
            if (!data) return;

            //subtotal either coming from overlay style response or non-overlay style response
            const payload = {
                cartId: data.cartId || "",
                subTotal: data.subTotal
                    ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.subTotal)
                    : data.cartSummary && data.cartSummary.cartSubTotal
                        ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.cartSummary.cartSubTotal)
                        : 0.00,
                products: []
            };

            // Find the products that were just added to the cart
            if (requestParams.itemList && requestParams.itemList.length > 0) {
                requestParams.itemList.forEach(addedItem => {
                    // Find the corresponding full item details in the cart's line items
                    var foundItem = false;
                    if(requestParams.addToCartFrom === "Forget Something" || requestParams.addToCartFrom === "carousel:ALTM" ) { // these do not have uom
                        foundItem = allLineItems.find(lineItem =>
                            lineItem.partNumber === addedItem.partNumber.replace(/-/g, "") && lineItem.variation !== "CS"
                        );
                    } else {
                        foundItem = allLineItems.find(lineItem =>
                            lineItem.partNumber === addedItem.partNumber.replace(/-/g, "") && lineItem.variation === addedItem.uom
                        );
                    }

                    if (foundItem) {
                        payload.products.push({
                            name: foundItem.productTitleNoGlyphs,
                            sku: foundItem.partNumber,
                            price: foundItem.price,
                            quantity: addedItem.quantity,
                            variation: foundItem.variation,
                            discount: ""
                        });
                    }
                });
            }

            const cartAddEvent = new CustomEvent('cartAdd', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartAddEvent);
        } catch (e) {
            window.fisherAnalytics.utils.log('Error in dispatchEnhancedCartAdd: ' + e);
        }
    },
    dispatchCartRemove: function(data, allLineItems) {
        try {
            if (!data || !allLineItems) return;

            const payload = {
                cartId: data.cartId || "",
                subTotal: data.cartSummary && data.cartSummary.cartSubTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.cartSummary.cartSubTotal) : 0.00,
                products: []
            };

            // Find the products that were just removed from the cart
            if (window.digitalData && window.digitalData.cart && window.digitalData.cart.products) {
                // Convert allLineItems to a format for easy comparison
                const currentProductKeys = allLineItems.map(item => item.partNumber + "_" + item.variation);

                // Loop through the previous cart products
                Object.entries(window.digitalData.cart.products).forEach(([key, product]) => {
                    // If a product exists in the previous cart but not in the current cart, it was removed
                    if (!currentProductKeys.includes(key)) {
                        payload.products.push({
                            name: product.name,
                            sku: product.sku,
                            price: product.price,
                            quantity: product.quantity,
                            variation: product.variation,
                            discount: ""
                        });
                    }
                });
            }

            const cartRemoveEvent = new CustomEvent('cartRemove', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartRemoveEvent);
        } catch (e) {
            window.fisherAnalytics.utils.log('Error in dispatchCartRemove: ' + e);
        }
    },
    // Process the XHR request
    // This function is called when the XHR request matches the URL pattern of:
    // add to carts, shipping and tax, removal of item from cart, update cart, save for later
    // we are populating the cart object in the data layer
    process: function(body, response, config) {
        if (response.responseText.indexOf(config.responseText) !== -1) {

            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                try {
                    if (data.cartEmpty && !config.saveForLater) { // cart is empty and not a save for later request
                        window.fisherAnalytics.cart.cartEmptyEvent();
                    }else if(!data.wasAdded && body && body.indexOf('Forget+Something') > -1){ //process Errors only forgot something
                        window.fisherAnalytics.cart.processErrors(data);
                    } else { // cart is not empty
                        var cartId = data && data.cartId ? data.cartId : "";
                        var overlayData = data.cartletItemsForAnalytics;
                        var nonOverlayData = data.cartSummary;

                        // Extract cart totals and cost breakdown to set the values in the digital data layer object
                        var totals = window.fisherAnalytics.cart.extractCartTotals(data, overlayData, nonOverlayData);
                        var cartSubTotal = totals.cartSubTotal;
                        var cartTotal = totals.cartTotal;
                        var costBreakdown = totals.costBreakdown;

                        //special flags used for specific scenarios and dispatching events
                        if(config.deleteItem) data.deleteItem = true; // if this is a delete item request, set deleteItem to true
                        if(config.updateItem) data.updateItem = true; // if this is an update item request, set updateItem to true,
                        if(config.moveToCart) data.moveToCart = true; // if this is a moveToCart from save for later, set moveToCart to true

                        // Extract line items to set the values in the digital data layer object
                        var lineItems = window.fisherAnalytics.cart.populateLineItemsAndSendEvents(body, data);

                        // Using digital-data.js methods and setting the cart and its items in the digital data layer object
                        if (window.digitalData && cartId) {
                            window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);
                            window.digitalDataManager.removeCartItems(); //clear products before repopulating
                            lineItems.forEach(function(item) {
                                window.digitalDataManager.setCartItem(item.lineItemID, item.partNumber, item.variation, item.productTitleNoGlyphs, item.price, item.quantity, item.findingMethod);
                            });

                            // Store cart details in local storage
                            window.fisherAnalytics.cart.saveCartDetailsToLocalStorage(cartId, cartSubTotal, cartTotal, costBreakdown, lineItems);
                        }
                    }
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (US): " + e);
                }
            }
        } else {
            window.fisherAnalytics.utils.log('no response from XHR request interceptor');
        }
    },
    // Extract cart totals and cost breakdown from response data
    // For the cart add response, there are 2 styles of response data:
    // A response where the cart add happens from the overlay and from nonoverlay
    extractCartTotals: function(data, overlayData, nonOverlayData) {
        var cartSubTotal = 0.00;
        var cartTotal = 0.00;
        var costBreakdown = {
            shippingCharges: {},
            taxes: {}
        };

        if (overlayData) { // overlay data response
            cartSubTotal = data.subTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.subTotal) : 0.00;
            cartTotal = data.orderTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(data.orderTotal) : 0.00;
        }

        if (nonOverlayData) { // non-overlay data response
            cartSubTotal = nonOverlayData.cartSubTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(nonOverlayData.cartSubTotal) : 0.00;
            cartTotal = nonOverlayData.orderTotal ? window.fisherAnalytics.utils.cleanAndConvertToFloat(nonOverlayData.orderTotal) : 0.00;
            var shippingAndTax = nonOverlayData.shippingAndTax;
            if (shippingAndTax) {
                if (shippingAndTax.shippingCharges) {
                    shippingAndTax.shippingCharges.forEach(function(shippingCharge) {
                        costBreakdown.shippingCharges[shippingCharge.description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(shippingCharge.chargeAmount);
                    });
                }
                if (shippingAndTax.taxes) {
                    shippingAndTax.taxes.forEach(function(tax) {
                        costBreakdown.taxes[tax.description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(tax.amount);
                    });
                }
            }
        }
        return {
            cartSubTotal: cartSubTotal,
            cartTotal: cartTotal,
            costBreakdown: costBreakdown
        };
    },
    //This function sends events for errors from add to cart requests specifically for the US
    //This is only related to errors coming from forgot something box on cart page
    processErrors: function(data) {
        if (data) {
            try {
                if (data.productsNotFoundQuickAdd) { // cart is empty and not a save for later request
                    document.dispatchEvent(new CustomEvent("trackError", {detail: {
                            errorCategory: "Forgot Something",
                            errorDescription: "SKU not valid: " + data.productsNotFoundQuickAdd}
                    }))
                } else if (data.unavailableItems) { // cart
                    // Loop through each unavailable item
                    Object.keys(data.unavailableItems).forEach(function(itemKey) {
                        var item = data.unavailableItems[itemKey];
                        if (item.itemCore && item.itemCore.partNumber) {
                            document.dispatchEvent(new CustomEvent("trackError", {detail: {
                                errorCategory: "Forgot Something",
                                errorDescription: "SKU Out of Stock: " + item.itemCore.partNumber}
                            }));
                        }
                    });
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with processErrors on data layer from global ui intercept (US): " + e);
            }
        }
    },
    processCA: function(body, response, config) {
        window.fisherAnalytics.utils.log('Process CA cartlet test');
        if (response.responseText.indexOf(config.responseText) !== -1 && env.programmaticCartletClick) {

            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                window.fisherAnalytics.utils.log('Process CA data 200');
                try{
                    // Extract line items
                    var cartId = window.fisherAnalytics.cart.getLegacyCartId();
                    var cartTotal = data.cartTotal || 0.00;
                    var costBreakdown = {};
                    var lineItems = window.fisherAnalytics.cart.populateLineItemsCA(data);
                    var cartSubTotal =  lineItems.cartSubTotal || 0.00;

                    if (window.digitalData) {
                        // Set cart and its items
                        window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);
                        var lastItem;
                        var existingProduct;
                        if (lineItems.length > 0) {
                            lastItem = lineItems[lineItems.length - 1];
                            existingProduct = (window.digitalData.cart && window.digitalData.cart.products && window.digitalData.cart.products[lastItem.lineItemID]) || false;
                        }

                        window.digitalDataManager.removeCartItems(); //clear products before repopulating
                        lineItems.forEach(function(item) {
                            window.digitalDataManager.setCartItem(item.lineItemID, item.partNumber, item.variation, item.productTitleNoGlyphs, item.price, item.quantity, item.findingMethod);
                        });

                        // Store cart details in local storage
                        window.fisherAnalytics.cart.saveCartDetailsToLocalStorage(cartId, cartSubTotal, cartTotal, costBreakdown, lineItems);
                        // Create and dispatch cartAdd event with the last item in lineItems
                        if (lastItem) {
                            const payload = {
                                cartId: cartId || "",
                                subTotal: cartSubTotal || 0.00,
                                products: [{
                                    name: lastItem.productTitleNoGlyphs,
                                    sku: lastItem.partNumber,
                                    price: lastItem.price,
                                    quantity: lastItem.quantity,
                                    variation: lastItem.variation,
                                    discount: ""
                                }]
                            };

                            const cartAddEvent = new CustomEvent('cartAdd', {
                                detail: {
                                    cartPayload: payload
                                }
                            });
                            // Dispatch event only if the product is not already in the data layer
                            if (!existingProduct){
                                document.dispatchEvent(cartAddEvent);
                            }
                        }
                    }
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (Canada): " + e);
                }
            }
        }
    },
    processCAFindingMethod: function(body, response, config) {
        window.fisherAnalytics.utils.log('Process CA finding method test');
        if (response.responseText.indexOf(config.responseText) !== -1) {
            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                window.fisherAnalytics.utils.log('Process CA data 200');
                try{
                    //Sending finding method to local storage so that it can get picked up later when the real cartlet & process call is made
                    var cartId = window.fisherAnalytics.cart.getLegacyCartId();
                    window.digitalDataManager.setCart(cartId, "", 0, {});
                    var addToCartFrom = "";
                    var catalogNumber = "";
                    if (typeof body === 'string') {
                        const params = window.fisherAnalytics.cart.parseLegacyAddToCartForm(body);
                        addToCartFrom = params.addToCartFrom || "";
                        catalogNumber = params.catalogNumber || "";
                        window.digitalDataManager.setCartItem(catalogNumber, catalogNumber, "", "", 0.0, 0, addToCartFrom);
                    }
                    delete window.digitalData.cart.products[catalogNumber] //clear product now that it is saved to local storage
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (Canada finding method): " + e);
                }
            }
        }
    },
    getLegacyCartId: function() {
        // For Canada, the cart ID is not provided by the backend.
        if(localStorage.getItem("CART_ID")) return localStorage.getItem("CART_ID");
        //No cartId in local storage, generate a new one
        if(window.utils){
            if(window.utils.getCookie('gsessionId')){
                window.fisherAnalytics.cart.setCACartId(window.utils.getCookie('gsessionId') + '-' + Date.now().toString().slice(-5));
                return localStorage.getItem("CART_ID");
            } else {
                return Date.now();
            }
        } else {
            return Date.now();
        }
    },
    setCACartId: function(cartId) {
        localStorage.setItem("CART_ID", cartId);
    },
    deleteCartId: function() {
        localStorage.removeItem("CART_ID");
        localStorage.removeItem("cartFindingMethod");
    },
    deleteFindingMethod: function() {
        localStorage.removeItem("cartFindingMethod");
    },
    callLegacyCartlet: function() {
        //This emulates clicking on the cart icon and will populate the cart id, finding method, and cart details in local storage
        //Mainly used for login Canada
        const xhr = new XMLHttpRequest();
        const nocache = Date.now();
        const url = `/shop/jsoncartlet?nocache=${nocache}`;

        xhr.open('GET', url, true);

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) { // Request is complete
                if (xhr.status === 200) { // Successfully received response
                    console.log('Response:', xhr.responseText);
                } else {
                    console.error('Error:', xhr.statusText);
                }
            }
        };
        xhr.send();
    },
    mergeLegacyCartChangeRecordsByCatNo: function () {
        // ---- helpers ----
        function safeParse(raw) {
            if (!raw) return {};
            try {
                var parsed = JSON.parse(raw);
                return (parsed && typeof parsed === "object" && !Array.isArray(parsed)) ? parsed : {};
            } catch (e) {
                if (window.console && console.warn) console.warn("Parse error:", e, raw);
                return {};
            }
        }

        function normalizeAction(val) {
            if (val == null) return "";
            return String(val).replace(/^\s+|\s+$/g, "").toLowerCase();
        }

        function deepParseValues(obj) {
            var out = {};
            for (var k in obj) {
                if (!obj.hasOwnProperty(k)) continue;
                var v = obj[k];
                if (typeof v === "string") {
                    try { out[k] = JSON.parse(v); }
                    catch (_e) { out[k] = v; }
                } else {
                    out[k] = v;
                }
            }
            return out;
        }

        function filterByAction(obj, wanted) {
            var wantedNorm = normalizeAction(wanted);
            var out = {};
            for (var key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                var value = obj[key];
                if (typeof value === "string") {
                    try { value = JSON.parse(value); } catch (_e) {}
                }
                if (value && typeof value === "object" && !Array.isArray(value)) {
                    var a = normalizeAction(value.action);
                    if (a === wantedNorm) out[key] = value;
                }
            }
            return out;
        }

        function extend(target, source) {
            for (var k in source) {
                if (source.hasOwnProperty(k)) target[k] = source[k];
            }
            return target;
        }

        function groupByCatNo(obj) {
            var grouped = {};
            for (var key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                var rec = obj[key];
                if (!rec || typeof rec !== "object") continue;
                var cat = rec.catNo || "_unknown";
                if (!grouped[cat]) grouped[cat] = [];
                grouped[cat].push(rec);
            }
            return grouped;
        }

        // --- merge each catNo's array into a single object ---
        function mergeGroupedRecords(grouped) {
            var merged = {};
            for (var cat in grouped) {
                if (!grouped.hasOwnProperty(cat)) continue;
                var list = grouped[cat];
                var combined = {};
                for (var i = 0; i < list.length; i++) {
                    var rec = list[i];
                    for (var key in rec) {
                        if (rec.hasOwnProperty(key)) combined[key] = rec[key];
                    }
                }
                merged[cat] = combined;
            }
            return merged;
        }

        // ---- load from BOTH storages ----
        var ss_cart   = safeParse(sessionStorage.getItem("cartUpdates"));
        var ls_cart   = safeParse(localStorage.getItem("cartUpdates"));
        var ss_units  = safeParse(sessionStorage.getItem("cartUnitUpdate"));
        var ls_units  = safeParse(localStorage.getItem("cartUnitUpdate"));

        // Merge local + session (session wins)
        var cartCombined = extend(extend({}, ls_cart), ss_cart);
        var unitCombined = extend(extend({}, ls_units), ss_units);

        cartCombined = deepParseValues(cartCombined);
        unitCombined = deepParseValues(unitCombined);

        var cartAdds     = filterByAction(cartCombined, "add");
        var cartRemoves  = filterByAction(cartCombined, "remove");
        var unitAdds     = filterByAction(unitCombined, "add");
        var unitRemoves  = filterByAction(unitCombined, "remove");

        var addsFlat    = extend(extend({}, cartAdds), unitAdds);
        var removesFlat = extend(extend({}, cartRemoves), unitRemoves);

        // Group by catNo then merge fields into one record per catNo
        var addsByCatNo    = mergeGroupedRecords(groupByCatNo(addsFlat));
        var removesByCatNo = mergeGroupedRecords(groupByCatNo(removesFlat));

        return {
            addsByCatNo: addsByCatNo,
            removesByCatNo: removesByCatNo,
            timestamp: new Date().toISOString()
        };
    },
    clearUpdateStorageLegacyCart: function() {
        sessionStorage.removeItem("cartUpdates");
        sessionStorage.removeItem("cartUnitUpdate");
    },
    processUpdateLegacyCartEvents : function() {
        //check for session storage cart updates and dispatch events accordingly
        const mergedRecords = window.fisherAnalytics.cart.mergeLegacyCartChangeRecordsByCatNo();
        const adds = mergedRecords.addsByCatNo;
        const removes = mergedRecords.removesByCatNo;
        let addedProducts = [];
        let removedProducts = [];
        let lookup;
        const payload = {
            cartId: window.fisherAnalytics.cart.getLegacyCartId(), // Cart ID not tracked here
            subTotal: digitalData.cart.subtotal || 0.00 // Subtotal not tracked here
        };

        // Dispatch cartAdd events
        for (const catNo in adds) {
            if (!adds.hasOwnProperty(catNo)) continue;
            const rec = adds[catNo];
            lookup = digitalData.cart.products ? digitalData.cart.products[catNo] : null;
            if(lookup){
                rec.name = lookup.name;
                rec.price = lookup.price;
                rec.qty = rec.newQty ? rec.newQty : rec.quantity;
                rec.variation = rec.newUnit ? rec.newUnit : lookup.variation;
            }
            addedProducts.push({
                findingMethod: "cartUpdate",
                name: rec.name || "",
                id: rec.catNo || "",
                price: rec.price || 0.00,
                quantity: rec.qty || 0,
                variation: rec.variation || "",
                discount: ""
            })
        }

        if (addedProducts.length > 0) {
            payload.products = addedProducts;
            const cartAddEvent = new CustomEvent('cartAdd', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartAddEvent);
        }
        // Dispatch cartRemove events
        for (const catNo in removes) {
            if (!removes.hasOwnProperty(catNo)) continue;
            lookup = digitalData.cart.products ? digitalData.cart.products[catNo] : null;
            const rec = removes[catNo];
            if(lookup){
                rec.name = lookup.name;
                rec.qty = rec.oldQty ? rec.oldQty : rec.quantity;
                rec.variation = rec.oldUnit ? rec.oldUnit : lookup.variation;
            }
            removedProducts.push({
                findingMethod: "cartUpdate",
                name: rec.name || "",
                id: rec.catNo || "",
                price: rec.price || 0.00,
                quantity: rec.qty || 0,
                variation: rec.variation || "",
                discount: ""
            })
        }
        if (removedProducts.length > 0) {
            payload.products = removedProducts;
            const cartRemoveEvent = new CustomEvent('cartRemove', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartRemoveEvent);
        }

        //Clear session storage after processing
        window.fisherAnalytics.cart.clearUpdateStorageLegacyCart();
    },
    processUpdateLegacyCart: function(e) {
        const element = e && e.target ? e.target : null;
        // ---------- storage helpers ----------
        function getUpdates() {
            try {
                const raw = sessionStorage.getItem("cartUpdates");
                const parsed = raw ? JSON.parse(raw) : {};
                return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
            } catch (e) { return {}; }
        }
        function saveUpdates(obj) {
            sessionStorage.setItem("cartUpdates", JSON.stringify(obj));
        }

        // ---------- parsing helpers ----------
        function parseQty(el) {
            const raw = (typeof el.value === "string" ? el.value : el.textContent) || "";
            const trimmed = raw.trim();
            if (trimmed === "") return null;
            const n = Number(trimmed);
            return Number.isFinite(n) ? n : null;
        }
        function getCatNoFromRow(el) {
            const tr = el.closest("tr");
            if (!tr) return null;
            const catEl = tr.querySelector('[name^="catno"]');
            if (!catEl) return null;
            return (catEl.textContent || catEl.value || "").trim() || null;
        }

        function getPriceFromQuantity(el) {
            if (!el) return null;

            // Find the table row that contains this quantity input
            var tr = el.closest ? el.closest("tr") : null;
            if (!tr) return null;

            // Look for the price within the same row
            // Adjust selector to match your actual markup (e.g., [name^="price"], .price, etc.)
            var priceEl = tr.querySelector('[name^="price"], .price, [data-price]');
            if (!priceEl) {
                // Fallback: try to find a dollar amount anywhere in the row text
                var text = tr.textContent || "";
                var matchFallback = text.match(/\$\s*([\d,]+(?:\.\d+)?)/);
                if (matchFallback && matchFallback[1]) {
                    var numFallback = parseFloat(matchFallback[1].replace(/,/g, ""));
                    return !isNaN(numFallback) ? parseFloat(numFallback.toFixed(2)) : null;
                }
                return null;
            }

            // Extract price text from element
            var priceText = (priceEl.textContent || priceEl.value || "").trim();
            var match = priceText.match(/\$\s*([\d,]+(?:\.\d+)?)/);

            if (match && match[1]) {
                var num = parseFloat(match[1].replace(/,/g, ""));
                if (!isNaN(num)) {
                    return parseFloat(num.toFixed(2));
                }
            }

            return null; // No price found
        }

        // ---------- baseline cache (persists across calls) ----------
        window._baselineQtyByName = window._baselineQtyByName || new Map();

        const name = element && element.getAttribute ? (element.getAttribute("name") || "") : "";
        if (!name) return; // need a stable key
        const catNo = getCatNoFromRow(element);
        const newQty = parseQty(element);
        const price = getPriceFromQuantity(element);
        if (newQty === null) return; // ignore empty / in-progress edits

        // Initialize baseline ON FIRST CALL using the element's original page-load value.
        if (!window._baselineQtyByName.has(name)) {
            var baseline = null;

            // 1) Inputs: use original page-load value (doesn't change as user edits)
            if ("defaultValue" in element) {
                const dv = (element.defaultValue || "").trim();
                if (dv !== "" && Number.isFinite(Number(dv))) baseline = Number(dv);
            }

            // 2) SSR/static value attribute fallback
            if (baseline === null) {
                const attrV = (element.getAttribute("value") || "").trim();
                if (attrV !== "" && Number.isFinite(Number(attrV))) baseline = Number(attrV);
            }

            // 3) Non-inputs: initial textContent
            if (baseline === null) {
                const tc = (element.textContent || "").trim();
                if (tc !== "" && Number.isFinite(Number(tc))) baseline = Number(tc);
            }

            // 4) Last resort: use the current numeric value (still proceed to log this change)
            if (baseline === null) baseline = newQty;

            window._baselineQtyByName.set(name, baseline);
            // IMPORTANT: do NOT return here — we proceed so the first change is recorded.
        }

        const baselineLocked = window._baselineQtyByName.get(name);
        const updates = getUpdates();

        // If user returns to baseline, remove any stored record
        if (newQty === baselineLocked) {
            if (updates[name]) {
                delete updates[name];
                saveUpdates(updates);
                console.log("Quantity reset to baseline (%s, Cat# %s): %d — entry removed.", name, catNo, baselineLocked);
            }
            return;
        }

        // Determine action by comparing to baseline
        const action = newQty > baselineLocked ? "add" : "remove";

        // Upsert one record per name
        updates[name] = {
            timestamp: new Date().toISOString(),
            name,
            catNo,
            oldQty: baselineLocked, // fixed to page-load value
            newQty,
            action,
            price
        };
        saveUpdates(updates);

        console.log("Quantity changed (%s, Cat# %s): %d → %d (%s)", name, catNo, baselineLocked, newQty, action);

    },
    processUpdateUnitLegacyCart: function(e) {
        const element = e && e.target ? e.target : null;

            // ---------- storage (localStorage) ----------
            function getUnitUpdates() {
                try {
                    const raw = sessionStorage.getItem("cartUnitUpdate");
                    const parsed = raw ? JSON.parse(raw) : {};
                    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
                } catch (e) { return {}; }
            }
            function saveUnitUpdates(obj) {
                sessionStorage.setItem("cartUnitUpdate", JSON.stringify(obj));
            }

            // ---------- helpers ----------
            function getCatNoFromRow(el) {
                const tr = el.closest("tr");
                if (!tr) return null;
                const catEl = tr.querySelector('[name^="catno"]');
                if (!catEl) return null;
                return (catEl.textContent || catEl.value || "").trim() || null;
            }
            function getCurrentQtyFromRow(el) {
                var tr = el.closest("tr");
                if (!tr) return null;
                var qtyEl = tr.querySelector('[name^="quantity"]');
                if (!qtyEl) return null;
                var val = qtyEl.value || qtyEl.textContent || "0";
                var n = parseFloat(val);
                return isNaN(n) ? 0 : n;
            }
            function getPriceFromRadio(el) {
                if (!el) return null;

                // Find the label wrapping or associated with this input
                var label = null;
                if (el.closest) {
                    label = el.closest('label');
                }
                if (!label) {
                    // Fallback: look for <label for="...">
                    var id = el.id || "";
                    if (id) {
                        label = document.querySelector('label[for="' + id + '"]');
                    }
                }
                if (!label) return null;

                // Extract text containing price
                var text = label.textContent || "";
                var match = text.match(/\$\s*([\d,]+(?:\.\d+)?)/);

                if (match && match[1]) {
                    // Remove commas, convert to float, round to 2 decimals
                    var num = parseFloat(match[1].replace(/,/g, ""));
                    if (!isNaN(num)) {
                        return parseFloat(num.toFixed(2));
                    }
                }

                return null; // No price found
            }

        function keyFor(name, unitValue) {
                return name + "|" + unitValue; // unique per radio option in a group
            }

            // ---------- baseline cache (by radio group name) ----------
            window._baselineUnitByName = window._baselineUnitByName || new Map();

            if (!element || !element.name) return;
            const groupName = element.name;             // e.g., "units0"
            const catNo = getCatNoFromRow(element);
            const currentQty = getCurrentQtyFromRow(element);
            const currentPrice = getPriceFromRadio(element); // may be null

            // Collect all radios in the same group
            const radios = Array.prototype.slice.call(
                document.querySelectorAll('input[type="radio"][name="' + groupName + '"]')
            );
            if (!radios.length) return;

            // Current selection (after this change)
            const selected = radios.find(r => r.checked);
            const currentValue = selected ? selected.value : null;
            if (currentValue == null) return; // nothing selected (shouldn’t happen for radios, but safe)

            // Establish baseline (page-load selection) once
            if (!window._baselineUnitByName.has(groupName)) {
                // Prefer the radio that was checked on initial render (defaultChecked)
                let baseline = null;
                const initiallyChecked = radios.find(r => r.defaultChecked);
                if (initiallyChecked) baseline = initiallyChecked.value;
                // Fallback: if no defaultChecked (SSR didn’t mark), use whatever is selected now
                if (baseline == null) baseline = currentValue;

                window._baselineUnitByName.set(groupName, baseline);
                // IMPORTANT: do NOT return — we still want to record this first change if it differs.
            }

            const baselineValue = window._baselineUnitByName.get(groupName);
            const updates = getUnitUpdates();

            // If user returned to baseline, clear all records for this group
            if (currentValue === baselineValue) {
                radios.forEach(r => {
                    const k = keyFor(groupName, r.value);
                    if (updates[k]) delete updates[k];
                });
                saveUnitUpdates(updates);
                console.log('Unit reset to baseline (%s): %s — entries cleared.', groupName, baselineValue);
                return;
            }

            // We "need a record for all units" in the group:
            // - baseline unit -> remove
            // - newly chosen unit -> add
            // - all other units -> remove any prior record (keep storage lean)
            const nowISO = new Date().toISOString();

            radios.forEach(radio => {
                const unitVal = radio.value;
                const k = keyFor(groupName, unitVal);

                if (unitVal === baselineValue && unitVal !== currentValue) {
                    // Baseline unit is no longer selected -> remove
                    updates[k] = {
                        timestamp: nowISO,
                        name: groupName,
                        catNo: catNo,
                        oldUnit: baselineValue,
                        newUnit: currentValue,
                        action: "remove",
                        quantity: currentQty,
                        price: currentPrice
                    };
                } else if (unitVal === currentValue && unitVal !== baselineValue) {
                    // Newly chosen unit -> add
                    updates[k] = {
                        timestamp: nowISO,
                        name: groupName,
                        catNo: catNo,
                        oldUnit: baselineValue,
                        newUnit: currentValue,
                        action: "add",
                        quantity: currentQty,
                        price: currentPrice
                    };
                } else {
                    // Any other unit option: no active change record
                    if (updates[k]) delete updates[k];
                }
            });

            saveUnitUpdates(updates);

            console.log(
                'Unit changed (%s, Cat# %s): %s → %s (add/remove records written)',
                groupName, catNo, baselineValue, currentValue
            );

    },
    populateLineItemsCA: function(data) {
        function toTwoDecimals(n) {
            return Math.round((parseFloat(n) || 0) * 100) / 100;
        }

        var lineItems = [];
        var cartSubTotal = 0.00;

        // Check all item groups and process their items
        var allGroups = ['regularGroup', 'luminexGroup', 'webreqGroup', 'genomicsGroup', 'oligosGroup'];

        allGroups.forEach(function(groupName) {
            if (data && data[groupName] && Array.isArray(data[groupName].items)) {
                data[groupName].items.forEach(function(item) {
                    var partNumber = item.productId ? item.productId.replace(/-/g, "") : "";
                    var productTitleNoGlyphs = item.productName || "";
                    var lineSubtotalRaw = item.subtotal || 0.00;
                    var quantity = item.quantity || 0;
                    var unitPrice = quantity > 0 ? (lineSubtotalRaw / quantity) : 0;
                    var price = toTwoDecimals(unitPrice); // unit price (2 decimals)
                    var variation = item.units || "";
                    var findingMethod = ""; //leave finding method empty for CA
                    // create running subtotal
                    cartSubTotal += lineSubtotalRaw;

                    lineItems.push({
                        lineItemID: partNumber,
                        partNumber: partNumber,
                        productTitleNoGlyphs: productTitleNoGlyphs,
                        price: price,
                        quantity: quantity,
                        variation: variation,
                        findingMethod: findingMethod
                    });
                });
            }
        });

        cartSubTotal = toTwoDecimals(cartSubTotal);
        lineItems.cartSubTotal = cartSubTotal;
        return lineItems;
    },
    processLegacyRemoveItem: function(e){
        try{
            const partNumber = e.currentTarget.querySelector('input').value.split('/').pop();
            const existingProduct = (window.digitalData.cart && window.digitalData.cart.products && window.digitalData.cart.products[partNumber]) || {};
            const payload = {
                cartId: window.digitalData.cart.id || "",
                subTotal: window.digitalData.cart.subtotal || 0.00,
                products: [{
                    name: existingProduct.name,
                    id: existingProduct.sku,
                    price: existingProduct.price,
                    quantity: existingProduct.quantity,
                    variation: existingProduct.variation,
                    discount: ""
                }]
            };
            const cartRemoveEvent = new CustomEvent('cartRemove', {
                detail: {
                    cartPayload: payload
                }
            });
            document.dispatchEvent(cartRemoveEvent);
        }catch (e){
            window.fisherAnalytics.utils.log("issue with processLegacyRemoveItem: " + e);
        }
    },
    // Process the legacy cart page (mostly used for Canada)
    // Parses details from HTML elements on the page and inserts them into the data layer
    processLegacyCartPage: function(){
        // Get the form element directly from the DOM - if no form we can assume the cart is empty
        const form = document.querySelector('form[name="ShoppingCartForm"]');
        if (!form || env.cartEmpty) {
            window.fisherAnalytics.cart.deleteCartId();
            window.fisherAnalytics.cart.deleteFindingMethod();
            return null;
        }

        // Create an object to hold the extracted data
        const cartItems = [];

        // Count how many items are in the cart
        const cartCountElement = form.querySelector('[name="cartcount"]');
        const cartCount = parseInt(cartCountElement ? cartCountElement.value : '0');

        // Loop through each item in the cart
        for (let i = 0; i < cartCount; i++) {
            const catnoElement = form.querySelector(`[name="catno${i}"]`);
            const catno = catnoElement ? catnoElement.value : '';
            const titleEle = document.querySelector(`[id="qa_ecs_cart_desc_${i}"]`);
            const title = titleEle ? titleEle.textContent.trim() : '';
            const unitsInput = form.querySelector(`[name="units${i}"]:checked`);
            const units = unitsInput ? unitsInput.value : '';
            const quantityElement = form.querySelector(`[name="quantity${i}"]`);
            const quantity = quantityElement ? quantityElement.value : '1';

            // Extract price from the label associated with the selected units radio button
            let price = 0;
            if (unitsInput) {
                const label = unitsInput.closest('label');
                if (label) {
                    // Extract price from label text (e.g., "$     102.12 / Pack of 12 Each")
                    const priceMatch = label.textContent.match(/\$\s*(\d+(\.\d+)?)/);
                    if (priceMatch && priceMatch[1]) {
                        price = parseFloat(priceMatch[1]);
                    }
                }
            }

            if (catno) {
                cartItems.push({
                    lineItemID: catno,
                    partNumber: catno,
                    productTitleNoGlyphs: title,
                    variation: units,
                    price: price,
                    quantity: parseInt(quantity) || 1,
                    findingMethod: ""
                });
            }
        }

        // Extract cart subtotal from product_subtotal_main in the context of the form
        let cartSubTotal = 0;
        const subtotalElement = form.querySelector('.product_subtotal_main .discount_price');
        if (subtotalElement) {
            const subtotalMatch = subtotalElement.textContent.match(/\$\s*(\d+(\.\d+)?)/);
            if (subtotalMatch && subtotalMatch[1]) {
                cartSubTotal = parseFloat(subtotalMatch[1]);
            }
        }

        // Extract cart total from product_item_grouptotal_element in the context of the form
        let cartTotal = 0;
        const totalElement = form.querySelector('.product_item_grouptotal_element h4');
        if (totalElement) {
            const totalMatch = totalElement.textContent.match(/\$\s*(\d+(\.\d+)?)/);
            if (totalMatch && totalMatch[1]) {
                cartTotal = parseFloat(totalMatch[1]);
            }
        }

        // Empty cost breakdown object
        const costBreakdown = {
            shippingCharges: {},
            taxes: {}
        };

        // populate tax info from data-tax-information attribute
        const taxElements = form.querySelectorAll('[data-tax-information]');
        taxElements.forEach(function(element) {
            const taxInfo = element.getAttribute('data-tax-information');
            if (taxInfo) {
                const parts = taxInfo.split('|');
                if (parts.length === 2) {
                    const description = parts[0];
                    const amount = parts[1];
                    costBreakdown.taxes[description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(amount);
                }
            }
        });

        // populate ship info from data-ship-information attribute
        const shippingElements = form.querySelectorAll('[data-ship-information]');
        shippingElements.forEach(function(element) {
            const shipInfo = element.getAttribute('data-ship-information');
            if (shipInfo) {
                const parts = shipInfo.split('|');
                if (parts.length === 2) {
                    const description = parts[0];
                    const amount = parts[1];
                    costBreakdown.shippingCharges[description] = window.fisherAnalytics.utils.cleanAndConvertToFloat(amount);
                }
            }
        });

        // Cart ID (empty string as it's not available in the legacy form)
        const cartId = window.fisherAnalytics.cart.getLegacyCartId();

        if (window.digitalData) {
            // Set cart and its items
            window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);
            window.digitalDataManager.removeCartItems(); //clear products before repopulating
            cartItems.forEach(function(item) {
                window.digitalDataManager.setCartItem(item.lineItemID, item.partNumber, item.variation, item.productTitleNoGlyphs, item.price, item.quantity, item.findingMethod);
            });

            // Store cart details in local storage
            window.fisherAnalytics.cart.saveCartDetailsToLocalStorage(cartId, cartSubTotal, cartTotal, costBreakdown, cartItems);
        }
    },
    // Populate line items based on the style of response data
    // (Overlay data, non-overlay data, configurator data)
    // Send events here for add / remove cart functions
    populateLineItemsAndSendEvents: function(body, data) {
        // Extract request data
        const requestParams = window.fisherAnalytics.cart.extractRequestParameters(body);
        const lineItems = [];

        // Process each data type in sequence
        // The following is what will actually set the lineItems array
        // by adding items to it from each data type present in the cart
        window.fisherAnalytics.cart.processOverlayData(data, requestParams, lineItems);
        window.fisherAnalytics.cart.processNonOverlayData(data, requestParams, lineItems);
        window.fisherAnalytics.cart.processConfiguratorData(data, lineItems);

        // The updateItem condition is for a specific add/remove scenario for updating the quantity on the cart page
        if (data.updateItem) {
            window.fisherAnalytics.cart.checkAndDispatchQuantityReduction(lineItems, requestParams);
        } else {
            // Dispatch cart add/remove events
            // The condition here is that we want to skip counting any save for later events because these
            // are manually tracked with the cart ui app and not here in global ui
            if (body && (requestParams.addToCartFrom.indexOf('for Later') === -1 || data.moveToCart)) { // add event (exclude 'for Later' scenarios)
                window.fisherAnalytics.cart.dispatchEnhancedCartAdd(data, requestParams, lineItems);
            } else if (data.deleteItem) { // remove event
                window.fisherAnalytics.cart.dispatchCartRemove(data, lineItems);
            }
        }
        return lineItems;
    },
    // Check for quantity addition/reduction and dispatch cart events if needed
    // This is based on a quantity change happening on the cart page in the US
    checkAndDispatchQuantityReduction: function(lineItems, requestParams) {
        if (!requestParams.itemList || !window.digitalData || !window.digitalData.cart || !window.digitalData.cart.products) {
            return;
        }

        requestParams.itemList.forEach(requestItem => {
            const partNumber = requestItem.partNumber.replace(/-/g, "");
            const variation = requestItem.uom;
            const lineItemKey = partNumber + "_" + variation;
            const newQuantity = parseInt(requestItem.quantity) || 0;

            // Check if this product exists in the current cart
            const existingProduct = window.digitalData.cart.products[lineItemKey];
            if (existingProduct && existingProduct.quantity > newQuantity) {
                // Quantity was reduced, dispatch cart remove event with the difference
                const quantityDifference = existingProduct.quantity - newQuantity;
                const payload = {
                    cartId: window.digitalData.cart.id || "",
                    subTotal: window.digitalData.cart.subtotal || 0.00,
                    products: [{
                        name: existingProduct.name,
                        sku: existingProduct.sku,
                        price: existingProduct.price,
                        quantity: quantityDifference,
                        variation: existingProduct.variation,
                        discount: ""
                    }]
                };

                const cartRemoveEvent = new CustomEvent('cartRemove', {
                    detail: {
                        cartPayload: payload
                    }
                });
                document.dispatchEvent(cartRemoveEvent);
            } else if (existingProduct && existingProduct.quantity < newQuantity) {
                // Quantity was increased, dispatch cart add event with the difference
                const quantityDifference = newQuantity - existingProduct.quantity;
                const payload = {
                    cartId: window.digitalData.cart.id || "",
                    subTotal: window.digitalData.cart.subtotal || 0.00,
                    products: [{
                        name: existingProduct.name,
                        sku: existingProduct.sku,
                        price: existingProduct.price,
                        quantity: quantityDifference,
                        variation: existingProduct.variation,
                        discount: ""
                    }]
                };

                const cartAddEvent = new CustomEvent('cartAdd', {
                    detail: {
                        cartPayload: payload
                    }
                });
                document.dispatchEvent(cartAddEvent);
            } else{
                window.fisherAnalytics.cart.checkAndDispatchUomChange(lineItems, requestParams); //uom change and not qty change
            }
        });
    },
    // Check for UOM change and dispatch cart remove/add events
    checkAndDispatchUomChange: function(lineItems, requestParams) {
        if (!requestParams.itemList || !window.digitalData || !window.digitalData.cart || !window.digitalData.cart.products) {
            return;
        }

        requestParams.itemList.forEach(requestItem => {
            const partNumber = requestItem.partNumber.replace(/-/g, "");
            const newUom = requestItem.uom;

            // Search through all products to find matching part number
            Object.entries(window.digitalData.cart.products).forEach(([lineItemKey, existingProduct]) => {
                if (existingProduct.sku === partNumber) {
                    // Find the corresponding item in lineItems for the new UOM and part number
                    const newLineItem = lineItems.find(item =>
                        item.partNumber === partNumber && item.variation === newUom
                    );

                    // Dispatch cart remove event for the existing product
                    const removePayload = {
                        cartId: window.digitalData.cart.id || "",
                        subTotal: window.digitalData.cart.subtotal || 0.00,
                        products: [{
                            name: existingProduct.name,
                            sku: existingProduct.sku,
                            price: existingProduct.price,
                            quantity: existingProduct.quantity,
                            variation: existingProduct.variation,
                            discount: ""
                        }]
                    };

                    const cartRemoveEvent = new CustomEvent('cartRemove', {
                        detail: {
                            cartPayload: removePayload
                        }
                    });
                    document.dispatchEvent(cartRemoveEvent);

                    // Dispatch cart add event with the new UOM and price from lineItems
                    const addPayload = {
                        cartId: window.digitalData.cart.id || "",
                        subTotal: window.digitalData.cart.subtotal || 0.00,
                        products: [{
                            name: existingProduct.name,
                            sku: existingProduct.sku,
                            price: newLineItem ? newLineItem.price : existingProduct.price,
                            quantity: existingProduct.quantity,
                            variation: newUom,
                            discount: ""
                        }]
                    };

                    const cartAddEvent = new CustomEvent('cartAdd', {
                        detail: {
                            cartPayload: addPayload
                        }
                    });
                    document.dispatchEvent(cartAddEvent);
                }
            });
        });
    },
    // Extract parameters from request body
    extractRequestParameters: function(body) {
        const pageName = window.fisherAnalytics.utils.getPageName();
        let addToCartFrom = "";
        let itemList = [];

        if (typeof FormData !== 'undefined' && body instanceof FormData) {
            const params = window.fisherAnalytics.cart.parseQuotesFormAddToCart(body);
            addToCartFrom = params.addToCartFrom || "";
            itemList = params.itemList || [];
        } else if (body) {
            const params = window.fisherAnalytics.utils.parseQueryString(body);
            addToCartFrom = params.addToCartFrom || pageName;
            itemList = params.itemList || [];
        }
        return { addToCartFrom, itemList, pageName };
    },
    parseEmailPartNumbers: function(url) {
        // Extract the emailPartNumbers parameter from the URL
        const regex = /[?&]emailPartNumbers=([^&#]*)/;
        const match = url.match(regex);

        if (!match) return [];

        // Decode the URL-encoded string and split by pipe character
        const emailPartNumbersParam = decodeURIComponent(match[1]);
        const partNumbers = emailPartNumbersParam.split('|');

        // Return array of clean part numbers
        return partNumbers.map(partNumber => partNumber.replace(/-/g, "").trim());
    },
    // Determine finding method for an item
    getFindingMethod: function(partNumber, variation, requestParams) {
        const { addToCartFrom, itemList, pageName } = requestParams;
        const pageURL = window.fisherAnalytics.utils.getPageURL();

        // Check for part numbers from email links
        if (variation && pageURL.indexOf('emailPartNumbers') !== -1) {
            const emailPartNumbers = this.parseEmailPartNumbers(pageURL);
            if (emailPartNumbers.includes(partNumber)) {
                return "email";
            }
        }

        for (let i = 0; i < itemList.length; i++) {
            if (itemList[i].partNumber == partNumber && itemList[i].uom === variation) {
                if (pageName.indexOf('special-offers-and-programs') !== -1) {
                    return "Special Offers"; // Override for special offers page
                } else {
                    return addToCartFrom;
                }
            } else if (itemList[i].partNumber == partNumber && addToCartFrom === "Forget Something") {
                return "Forget Something"; // Override for Forget Something
            } else if (itemList[i].partNumber == partNumber && addToCartFrom === "carousel:ALTM") {
                return "carousel:ALTM"; // Override for alternates carousel on PDP
            }else if(variation && pageURL.indexOf('emailPartNumbers') != 0){

            }
        }
        return "";
    },
    // Process overlay data
    processOverlayData: function(data, requestParams, lineItems) {
        if (!data.cartletItemsForAnalytics) return;
        data.cartletItemsForAnalytics.forEach(item => {
            const partNumber = item.partNumber.replace(/-/g, "");
            const variation = item.uom;
            lineItems.push({
                lineItemID: partNumber + "_" + variation,
                partNumber: partNumber,
                productTitleNoGlyphs: item.productTitleNoGlyphs,
                price: window.fisherAnalytics.utils.cleanAndConvertToFloat(item.itemPrice),
                quantity: item.quantity,
                variation: variation,
                findingMethod: window.fisherAnalytics.cart.getFindingMethod(partNumber, variation, requestParams)
            });
        });
    },
    // Process non-overlay data (regular line items / stock items)
    processNonOverlayData: function(data, requestParams, lineItems) {
        if (!data.lineItems && !data.stockItems) return;

        // Map of types to finding methods
        const dataTypes = {
            'lineItems': function(partNumber, variation) {
                return window.fisherAnalytics.cart.getFindingMethod(partNumber, variation, requestParams);
            },
            'stockItems': function() {
                return 'Stock Item';
            }
        };

        // Process each data type in a single loop
        Object.keys(dataTypes).forEach(dataType => {
            if (!data[dataType]) return;

            Object.keys(data[dataType]).forEach(key => {
                const item = data[dataType][key];
                const partNumber = item.itemCore.partNumber.replace(/-/g, "");
                const productTitleNoGlyphs = item.itemCore.productTitleNoGlyphs;
                let price = "";
                let quantity = 0;
                let variation = "";

                item.priceUoms.forEach(priceUom => {
                    if (priceUom.selected) {
                        price = window.fisherAnalytics.utils.cleanAndConvertToFloat(priceUom.itemPrice);
                        quantity = priceUom.quantity;
                        variation = priceUom.uom;
                    }
                });

                lineItems.push({
                    lineItemID: partNumber + "_" + variation,
                    partNumber: partNumber,
                    productTitleNoGlyphs: productTitleNoGlyphs,
                    price: price,
                    quantity: quantity,
                    variation: variation,
                    findingMethod: dataTypes[dataType](partNumber, variation)
                });
            });
        });
    },
    // Process configurator cart data
    processConfiguratorData: function(data, lineItems) {
        if (!data.configItems) return;

        // Map of configurator types to finding methods
        const configuratorTypes = {
            'rndItem': 'RNDSystem',
            'lsgItem': 'LSG',
            'emoleculesItem': 'Emolecules'
        };

        // Process each configurator type
        Object.keys(configuratorTypes).forEach(configType => {
            if (!data.configItems[configType] || !data.configItems[configType].lineItems) return;

            const findingMethod = configuratorTypes[configType];
            const items = data.configItems[configType].lineItems;

            Object.keys(items).forEach(key => {
                const lineItem = items[key];
                const partNumber = lineItem.itemCore.partNumber.replace(/-/g, "");
                const productTitleNoGlyphs = lineItem.itemCore.productTitleNoGlyphs;
                let price = "";
                let quantity = 0;
                let variation = "";

                lineItem.priceUoms.forEach(priceUom => {
                    if (priceUom.selected) {
                        price = window.fisherAnalytics.utils.cleanAndConvertToFloat(priceUom.itemPrice);
                        quantity = priceUom.quantity;
                        variation = priceUom.uom;
                    }
                });

                lineItems.push({
                    lineItemID: partNumber + "_" + variation,
                    partNumber: partNumber,
                    productTitleNoGlyphs: productTitleNoGlyphs,
                    price: price,
                    quantity: quantity,
                    variation: variation,
                    findingMethod: findingMethod
                });
            });
        });
    },
    //this calls the minified cart endpoint to get the cart details
    //for now this is only used upon account login
    callMinifiedCart: function () {
        try {
            // Set session storage before the request
            sessionStorage.setItem("callMinifiedCart", "true");
            const xhr = new XMLHttpRequest();
            xhr.open('GET', '/store1/cart/service/minifiedcart', true);
            xhr.onload = function() {
                if (xhr.status >= 200 && xhr.status < 300) { // Success
                    try {
                        const json = JSON.parse(xhr.responseText);
                        if (typeof json.status !== 'undefined' && json.status === 500) {
                            window.fisherAnalytics.utils.log('minifiedcartdetails call Internal Server Error - from globalUI cart.js');
                        }
                    } catch (e) {
                        window.fisherAnalytics.utils.log('Error parsing JSON response from minifiedcartdetails: ' + e);
                    }
                } else { // Error (e.g., 404, 500 from server, not a network error)
                    window.fisherAnalytics.utils.log('minifiedcartdetails call Error - from globalUI cart.js ' + xhr.status + ' ' + xhr.statusText);
                }
                sessionStorage.removeItem("callMinifiedCart");
            };

            xhr.onerror = function() {// Network error
                window.fisherAnalytics.utils.log('minifiedcartdetails call Error - from globalUI cart.js Network error');
                sessionStorage.removeItem("callMinifiedCart"); // Ensure removal on network error
            };

            xhr.send();
        } catch (e) {
            window.fisherAnalytics.utils.log('minifiedcartdetails call catch error - from globalUI cart.js', e);
            if (sessionStorage.getItem("callMinifiedCart")) {
                sessionStorage.removeItem("callMinifiedCart");
            }
        }
    },
    //Save cart details to localStorage
    //for later retrieval
    saveCartDetailsToLocalStorage: function (cartId, cartSubTotal, cartTotal, costBreakdown, lineItems) {
        var cartDetails = {
            cartId: cartId,
            cartSubTotal: cartSubTotal,
            cartTotal: cartTotal,
            costBreakdown: costBreakdown,
            lineItems: lineItems
        };
        localStorage.setItem('cartDetails', JSON.stringify(cartDetails));
    },
    // Retrieves the cart details from localStorage and sets the data layer
    retrieveAndSetCartData: function() {
        try{
            const cartDetailsJSON = localStorage.getItem('cartDetails');
            if (cartDetailsJSON) {
                const cartDetails = JSON.parse(cartDetailsJSON);

                // Destructure the necessary values from cartDetails
                let  { cartId, cartSubTotal, cartTotal, costBreakdown, lineItems } = cartDetails;

                //Check local storage for a cart ID
                if(localStorage.getItem('CART_ID') !== null){
                    cartId = window.fisherAnalytics.cart.getLegacyCartId();
                }

                // Call the setCart function with the values from cartDetails
                window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);

                // Iterate through each line item and call setCartItem
                lineItems.forEach(item => {
                    const { findingMethod, lineItemID, partNumber, productTitleNoGlyphs, price, quantity, variation } = item;
                    window.digitalDataManager.setCartItem(lineItemID, partNumber, variation, productTitleNoGlyphs, price, quantity, findingMethod);
                });
            }
        } catch (e){
            window.fisherAnalytics.utils.log("issue with retrieving cart data from localStorage: " + e);
        }
    },
    parseQuotesFormAddToCart: function(quotesForm) {
        let params = {
            addToCartFrom: 'QuotesAddItemsToCart',
            itemList: []
        };
        try{
            quotesForm.forEach((value, key) => {
                // Determine the index and actual key
                const match = key.match(/^(\d+)(.*)$/);
                if (match) {
                    const index = parseInt(match[1], 10);
                    const actualKey = match[2];
                    // Ensure the item at the index exists
                    if (!params.itemList[index]) {
                        params.itemList[index] = {};
                    }
                    // Map the keys to the desired format
                    switch (actualKey) {
                        case '_partNumber':
                            params.itemList[index].partNumber = value;
                            break;
                        case 'units':
                            params.itemList[index].uom = value;
                            break;
                        case '_desired_quantity':
                            params.itemList[index].quantity = value;
                            break;
                        default:
                            params.itemList[index][actualKey] = value;
                    }
                } else {
                    // Handle non-indexed keys
                    params[key] = value;
                }
            });
        }catch (e) {
            window.fisherAnalytics.utils.log("issue with parsing quotes form data: " + e);
        }
        return params;
    },
    // In `public/analytics/cart.js`
    parseLegacyAddToCartForm: function(body) {
        const params = {
            addToCartFrom: '',
            catalogNumber: '',
            unit: ''
        };
        try {
            if (typeof body === 'string') {
                body.split('&').forEach(pair => {
                    if (!pair) return;
                    const [rawKey, rawVal] = pair.split('=');
                    const key = decodeURIComponent(rawKey || '').trim();
                    const value = decodeURIComponent((rawVal || '').replace(/\+/g, ' ')).trim();
                    if (key === 'addToCartFrom') {
                        params.addToCartFrom = value;
                    } else if (key === 'shoppingCartCatNum') {
                        params.catalogNumber = value;
                    } else if (key === 'shoppingCartUnits') {
                        params.unit = value;
                    }
                });
                return params;
            }
        } catch (e) {
            window.fisherAnalytics.utils.log("issue with parsing legacy form/body data: " + e);
        }
        return params;
    },
    // Retrieves the cart data from localStorage and sets the data layer with a limit on attempts
    // to check for the presence of digitalData
    retrieveAndSetCartDataWithLimit: function(attempts) {
        var attemptCount = 0;
        var interval = setInterval(function() {
            if (window.digitalData) {
                clearInterval(interval);
                window.fisherAnalytics.cart.retrieveAndSetCartData();
            } else if (attemptCount >= attempts) {
                clearInterval(interval);
            } else {
                attemptCount++;
            }
        }, 100);
    }
};

// Initialize the cart module
window.fisherAnalytics.cart.init();
